var HealthTypesDescription = {
  UNHEALTHY: "One or more health checks are failing.",
  HEALTHY: "This service is operating normally.",
  IDLE: "This service has no running tasks.",
  NA: "No health checks are set up for this service."
};

module.exports = HealthTypesDescription;



// WEBPACK FOOTER //
// ./plugins/services/src/js/constants/HealthTypesDescription.js